// components/dashboard/UserInfo.jsx
import React from 'react';
import Card from '../common/Card';
import useAuth from '../../hooks/useAuth';

const UserInfo = () => {
  const { user } = useAuth();
  
  return (
    <Card title="Kullanıcı Bilgileri">
      <div className="flex items-center space-x-4">
        <div className="bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full p-3 shadow-lg">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <div>
          <h3 className="text-xl font-semibold text-blue-100">{user?.name}</h3>
          <p className="text-sm text-blue-300">{user?.email}</p>
        </div>
      </div>
    </Card>
  );
};

export default UserInfo;